if (!customElements.get('grid-item-slider')) {
  class GridItemSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.mediaQuery = window.matchMedia('(max-width: 880px)');
      this.initAttempts = 0;
      this.handleMediaChange = this.handleMediaChange.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // During initial HTML parsing, connectedCallback can fire before this
      // element's own children (e.g. .swiper) have been parsed, so wait for both.
      if (typeof Swiper !== 'undefined' && this.querySelector('.swiper')) {
        this.handleMediaChange();
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      } else if (this.initAttempts < 50) {
        // Not ready yet, wait and retry (max 5 seconds)
        this.initAttempts++;
        setTimeout(() => this.init(), 100);
      }
    }

    handleMediaChange() {
      if (this.mediaQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper) return;

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });

      // Prevent link click when swiping
      let slideChanged = false;
      
      this.swiper.on('slideChange', () => {
        slideChanged = true;
      });

      this.swiper.on('touchStart', () => {
        slideChanged = false;
      });

      this.swiper.on('touchEnd', () => {
        if (slideChanged) {
          const link = this.closest('a');
          if (link) {
            link.style.pointerEvents = 'none';
            setTimeout(() => link.style.pointerEvents = '', 100);
          }
        }
      });
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    disconnectedCallback() {
      this.destroySwiper();
      this.mediaQuery.removeEventListener('change', this.handleMediaChange);
    }
  }

  customElements.define('grid-item-slider', GridItemSlider);
}
